import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ItemDetalhado } from 'src/app/persistences/item-detalhado';
import { ImagemAmpliadaComponent } from '../imagem-ampliada/imagem-ampliada.component';

@Component({
  standalone: false,
  selector: 'app-item-descricao-detalhado',
  templateUrl: './item-descricao-detalhado.component.html',
  styleUrls: ['./item-descricao-detalhado.component.css']
})
export class ItemDescricaoDetalhadoComponent {

	private dialog = inject(MatDialog);

	@Input()
	public item: ItemDetalhado;
	@Input()
	public imageObject: Array<object> = [];
	@Input()
	public imagensCarregadas = false;

	ampliarImagem(index: number) {
		this.dialog.open(ImagemAmpliadaComponent, {
			data: { images: this.imageObject, index },
			panelClass: 'imagem-ampliada-dialog',
			maxWidth: '100vw',
			width: '100vw',
			height: '100vh',
		});
	}
}